// ======================================================================
// File Name       : RegisterUserSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { reduxForm, isInvalid, change } from 'redux-form';
import { connect } from 'react-redux';
import { FormControl, Form, Col, Button, Row } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';
import SelectGroupDialog from '../SelectGroupDialog';
import { convertNodeGroupToNodeString } from '../../utils/UserUtils';
import ReduxFormPaging from '../ReduxFormPaging';
import CustomButton from '../button/CustomButton';

class RegisterUserSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.onSearchBtnClick = this.onSearchBtnClick.bind(this);
    this.showSelectGroupDialog = this.showSelectGroupDialog.bind(this);
    this.closeSelectGroupDialog = this.closeSelectGroupDialog.bind(this);
  }

  showSelectGroupDialog() {
    this.props.dispatch(
      change('searchUserForm', 'selectedTargetGroup', this.props.selectedTargetGroup),
    );
    this.setState({
      show: true,
    });
  }

  closeSelectGroupDialog() {
    this.setState({
      show: false,
    });
  }

  onSearchBtnClick() {
    const { invalid } = this.props;
    if (invalid) return;
    this.props.change('startPosition', 0);
    this.props.onSearchBtnClick(0);
  }

  render() {
    const {
      onSearchBtnClick,
      invalid,
      getStartEndData,
      recordNum,
      formValues,
      groupList,
      selectedTargetGroup,
      handleCheckAll,
    } = this.props;
    let groupName = '';
    if (selectedTargetGroup && selectedTargetGroup.groupSecernId && groupList) {
      const groupSecernId = selectedTargetGroup.groupSecernId;
      groupName = convertNodeGroupToNodeString(groupSecernId, groupList);
    }
    const style = {
      height: '120%',
    };
    return (
      <div>
        <Form onSubmit={this.props.handleSubmit} className='form-horizontal'>
          <Form.Group>
          <Row>
            <Col as={Form.Label} sm={3} className="text-left margin-bottom-15">
              ログインID
            </Col>
            <Col sm={9}>
              <RenderField type="text" name="loginId" />
            </Col>
            </Row>
          </Form.Group>
          <Form.Group>
          <Row>
            <Col as={Form.Label} sm={3} className="text-left margin-bottom-15">
              ユーザー名
            </Col>
            <Col sm={9}>
              <RenderField type="text" name="userName" />
            </Col>
            </Row>
          </Form.Group>
          <Form.Group>
          <Row>
            <Col as={Form.Label} sm={3} className="text-left margin-bottom-15">
              ユーザーグループ名
            </Col>
            <Col sm={9}>
              <Button onClick={this.showSelectGroupDialog} variant="primary" className="btn-96">
                グループ選択
              </Button>
            </Col>
            </Row>
          </Form.Group>
          {groupName && (
          <Form.Group>
            <Col as={Form.Label} sm={3} className="text-left">
            </Col>
            <Col sm={7} as={Form.Label} className="ps-0">{groupName}
            </Col>
              <Col sm={2} className="d-flex justify-content-end">
                <Button
                  onClick={this.props.removeSelectedGroup}
                  variant="primary"
                  className="btn-96"
                >
                  削除
                </Button>
              </Col>
          </Form.Group>
            )}
          <Form.Group>
            <Col sm={12} className="text-center">
              {/* <Button
                onClick={this.props.handleSubmit(this.onSearchBtnClick)}
                bsStyle="primary"
                className="btn-96"
              >
                
              </Button> */}
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                handleClick={this.props.handleSubmit(this.onSearchBtnClick)}
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
          <SelectGroupDialog
            {...this.props.groupInfo}
            show={this.state.show}
            parent={this}
            showSelectGroupDialog={this.showSelectGroupDialog}
            closeSelectGroupDialog={this.closeSelectGroupDialog}
            formKey="searchUserForm"
            shouldSearchGroup={false}
            style={style}
          />
          <Form.Group>
            <Col sm={2} className="margin-top-15 margin-bottom-15">
              <Button variant="default" className="btn btn-default btn-96" onClick={handleCheckAll}>全選択/解除</Button>
            </Col>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { registerMessageThreadForm, searchUserForm } = state.form;
  const { selectedTargetGroup } = state.group;
  const { groupInfo, groupList } = state.messageThread;
  return {
    searchUserForm,
    registerMessageThreadForm,
    selectedTargetGroup,
    groupList,
    groupInfo,
    invalid: isInvalid('searchUserForm')(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'searchUserForm',
    touchOnChange: true,
    enableReinitialize: true,
  })(RegisterUserSearch),
);
